/**
 * Defines the type of entity being called or transferred to during outbound call operations.
 *
 * Used throughout the application to:
 * - Identify transfer target types (agent, queue, external number)
 */
export enum OutboundCallEntity {
  /** Internal agent/employee transfer or call */
  Employees = 'employee',
  /** Queue-based routing for inbound distribution */
  Queue = 'queue',
  /** External phone number (via keypad entry) */
  Keypad = 'external',
  /** ServiceTitan technician call */
  Technicians = 'technician',
}
